import React from 'react';
import { ErrorMessage, Field, FormikProps } from 'formik';
import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';
import zxcvbnEnPackage from '@zxcvbn-ts/language-pl';
import zxcvbnCommonPackage from '@zxcvbn-ts/language-common';

export function TextField(props: {
    name: string;
    type: 'password' | 'email' | 'text';
    formik: FormikProps<any>;
    placeholder?: string;
    label?: string;
    className?: string;
    disabled?: boolean;
    fieldClass?: string;
}) {
    return (
        <div className={`w-full ${props.className}`}>
            {props.label && (
                <label htmlFor={`field-${props.name}`} className={'ml-0.5'}>
                    {props.label}
                </label>
            )}
            <Field
                disabled={props.disabled}
                type={props.type}
                name={props.name}
                id={`field-${props.name}`}
                className={`
                focus-effect standard-behavior type-blue
                ${
                    props.formik.errors[props.name] &&
                    props.formik.touched[props.name] &&
                    'is-invalid'
                } 
                mt-0.5 w-full rounded px-2 py-1.5
                ${props.fieldClass}`}
                placeholder={props.placeholder}
            />

            <small className={'text-red-500'}>
                <ErrorMessage name={props.name} />
            </small>
        </div>
    );
}

export function ZXCVBNHelper(props: { password: string }) {
    const options = {
        translations: zxcvbnEnPackage.translations,
        graphs: zxcvbnCommonPackage.adjacencyGraphs,
        dictionary: {
            ...zxcvbnCommonPackage.dictionary,
            ...zxcvbnEnPackage.dictionary,
        },
    };
    zxcvbnOptions.setOptions(options);
    return (
        <>
            <div className="mt-2 h-2.5 w-full rounded-full bg-gray-200">
                <div
                    className={`${
                        zxcvbn(props.password).score <= 2
                            ? 'bg-red-600'
                            : zxcvbn(props.password).score === 3
                            ? 'bg-yellow-600'
                            : zxcvbn(props.password).score === 4 && 'bg-green-600'
                    } h-2.5 rounded-full`}
                    style={{
                        width: `${(zxcvbn(props.password).score / 4) * 100}%`,
                    }}></div>
            </div>
            <div className={'mx-1 mt-1 flex flex-col text-xs text-red-600'}>
                {zxcvbn(props.password).feedback.suggestions.map((suggestion, number) => {
                    return <div key={`password-suggestion-${number}`}>{suggestion}</div>;
                })}
            </div>
        </>
    );
}
